import React from 'react';
import PropTypes from 'prop-types';
import Info from '@mui/icons-material/Info';

import get from 'lodash/get';

import { registerDecoration } from 'core/forms';

import { Typo } from 'uikit/content';

import InfoBox from '../../exceed/components/infoBox';

import styles from '../styles/formDecorationDynamicInfo.module.scss';

const FormDecorationDynamicInfo = ({ model, schema }) => {
  const { textPath } = schema;
  const text = get(model, textPath);

  if (!text) return null;

  return (
    <InfoBox className={styles.infoBox}>
      <Info className={styles.icon} sx={{ height: 18, width: 18 }} />
      <Typo element="span" variant="b01">
        {text}
      </Typo>
    </InfoBox>
  );
};

FormDecorationDynamicInfo.propTypes = {
  model: PropTypes.shape({}).isRequired,
  schema: PropTypes.shape({ textPath: PropTypes.string.isRequired }).isRequired,
};

registerDecoration('DynamicInfo', React.memo(FormDecorationDynamicInfo));

export default FormDecorationDynamicInfo;
